import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SuppliersService } from 'ngx-paf-common';
import { ExtUser } from 'ngx-paf-common';

@Component({
  selector: 'app-confirmation-register',
  templateUrl: './confirmation-register.component.html',
  styleUrls: ['./confirmation-register.component.scss']
})
export class ConfirmationRegisterComponent implements OnInit {

  id: number = 0;
  newExtUser:ExtUser= new ExtUser();
  constructor(
    private route: ActivatedRoute,
    private suppliersSvc: SuppliersService    
    ) { }

  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.suppliersSvc.getNewExtUser(this.id).subscribe((result:ExtUser)=> this.newExtUser = result);
  }

}
